<template>
    <div class="container">
        <div style="max-width: 100%">
            <div class="title">School Code (DBN) </div>
            <div class="d-flex align-center mt-2 gap-4">
                <v-text-field
                    density="comfortable"
                    color="primary"
                    bg-color="white"
                    v-model="nycdoeDBN"
                    style="width: 300px"
                    class="custom-input"
                    :loading="$props.loadingIntegration"
                    data-cy="integration-nyc_school_code"
                    @update:model-value="emitSchoolCode"
                ></v-text-field>
            </div>
        </div>
        <ecsTaskSync integration_type="nycdoe"/>
    </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import EcsTaskSync from '@/components/school/integration/ecsTaskSync.vue';

const props = defineProps<{
    nycdoe_school_code: string;
    loadingIntegration: boolean;
}>();

const emit = defineEmits<{
    'update:nycdoe_school_code': [value: string];
    'reload:data': [];
}>();

const nycdoeDBN = ref(props.nycdoe_school_code);

// Watch for prop changes from parent
watch(() => props.nycdoe_school_code, (newValue) => {
    nycdoeDBN.value = newValue;
});

const emitSchoolCode = (value: string) => {
	// Emit the updated value to the parent
	emit("update:nycdoe_school_code", value);
};
</script>
<style scoped lang="scss"></style>